// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/combos/remover — soft-delete: `active = 0`, a
 * rede desliga o combo em toda franquia. A linha fica na gestao para religar.
 */
import { registerContract } from './validate'

export interface Combos_RemoverInput {
so_combo_id: number
}

registerContract('Combos_RemoverInput', {
  so_combo_id: { type: 'number',  required: true },
})
